// src/features/quote/useQuote.js
import { useEffect, useMemo, useState } from "react";

export default function useQuote({ svc, defaultValidDays = 14 }) {
  const [open, setOpen] = useState(false);

  // Slå av/på egen print-kontekst for pristilbud
  useEffect(() => {
    if (open) document.body.classList.add("printing-quote");
    else document.body.classList.remove("printing-quote");
    return () => document.body.classList.remove("printing-quote");
  }, [open]);

  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  };

  const validUntil = useMemo(
    () => (svc ? addDays(new Date(), defaultValidDays) : null),
    [svc, defaultValidDays]
  );

  return {
    open,
    setOpen,
    show: () => setOpen(true),
    hide: () => setOpen(false),
    validUntil,
  };
}
